import {Dispatcher} from "../../stem-core/src/base/Dispatcher";

let lastPageAccessed = null;
let pageAccessDispatcher = null;
let pageAccessCheckInterval = null;

export function onPageAccess(callback) {
    if (pageAccessDispatcher == null) {
        lastPageAccessed = window.location.href;
        pageAccessDispatcher = new Dispatcher();
        pageAccessCheckInterval = setInterval(() => {
            const currentUrl = window.location.href;
            if (currentUrl !== lastPageAccessed) {
                lastPageAccessed = currentUrl;
                pageAccessDispatcher.dispatch(currentUrl);
            }
        }, 200);
    }
    callback(lastPageAccessed);
    return pageAccessDispatcher.addListener(callback);
}

// Cleanup the onPageAccess timeout and all listeners. Useful for tests.
export function cleanupOnPageAccess() {
    if (pageAccessDispatcher != null) {
        clearInterval(pageAccessCheckInterval);
        pageAccessCheckInterval = null;
        pageAccessDispatcher.removeAllListeners();
        pageAccessDispatcher = null;
        lastPageAccessed = null;
    }
}
